import React, { useState, useEffect } from 'react';
//import { s3ListObjects, s3ReadFile, s3WriteFile, s3DeleteFile } from '../components/s3Utils';
import { s3ReadFile, s3ListObjects, s3WriteFile } from '../components/s3Utils';
import { Button, useAuthenticator, Loader, Text, TextField, SelectField, Heading, Divider, Grid, View } from '@aws-amplify/ui-react';
import { Offcanvas, Container } from 'react-bootstrap';
import { MdSave, MdDoneOutline } from 'react-icons/md'
// import background from '../components/assets/table-2879213_1920.jpg';
import Footer from '../components/lib/Footer';
import { Navigate } from 'react-router-dom';
import { getDateTime } from "../components/lib/DatumToString";


const Loading = (props) => {
    const [percentage, setPercentage] = useState(0);
    // console.log('Loading...')

    useEffect(() => {

        const clearID = setInterval(() => {
            setPercentage((percentage) => {
                if (percentage < 100) {
                    return percentage + 1;
                }
                return 0;
            });
        }, 50);
        return () => clearInterval(clearID);
    }, []);

    return (
        <>
            <Text>Loading {props.loadingtext}...</Text>
            <Loader size="large" percentage={percentage} isDeterminate>
            </Loader>
        </>
    )
}

const AdressEingabe = (props) => {
    const items = ['PRAXIS', 'ANREDE', 'TITEL', 'VORNAME', 'NAME', 'STRASSE', 'HAUSNUMMER', 'PLZ', 'ORT', 'TELEFON'];

    const initAddress = (data) => {
        const theObj = {}
        items.forEach(item => {
            theObj[item] = data[item] || '';
        })
        return theObj;
    }

    // console.log(props)
    const [data, setData] = useState(props.adresse ? initAddress(props.adresse) : {})

    const handleChange = (e) => {
        const Name = e.target.name.toUpperCase();
        // console.log(Name);
        let value = e.target.value.replace(/;/g, '');
        if (Name === 'PLZ') {
            const c = value.slice(-1);
            if ((!/^\d$/.test(c[0]) && c !== '') || value.length > 5) {
                // console.log('PLZ is not a number or too long');
                value = data['PLZ'];
            }
        }
        if (Name === 'TELEFON') {
            const c = value.slice(-1);
            if ((!/[\d|(|)|+|\-| ]/.test(c[0]) && c !== '') || value.length > 30) {
                value = data['TELEFON'];
            }
        }
        const oldData = initAddress(data);
        const newData = { ...oldData, [Name]: value };
        setData(newData)
        props.handleChange(newData);
    }

    return (
        <Grid
            templateColumns="repeat(5, 1fr)"
            columnGap="0.5rem"
            rowGap="0.5rem"
        >
            {props.PRAXIS_YN === 1 &&
                <>

                    <View columnSpan={5}>
                        <TextField
                            name='Praxis'
                            outerStartComponent={<Button size="small" tabIndex={-1}>Praxis/KH:</Button>}
                            label="Praxis/Klinik:"
                            size="small"
                            placeholder='Praxisbezeichnung / Klinik'
                            width="100%"
                            maxLength={50}
                            labelHidden={true}
                            onChange={handleChange}
                            value={data['PRAXIS']}
                        />
                    </View>
                </>
            }

            <View columnSpan={2}>
                <SelectField
                    name='Anrede'
                    label="Anrede:"
                    size="small"
                    placeholder='Anrede'
                    maxLength={5}
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['ANREDE']}
                >
                    <option value="Frau">Frau</option>
                    <option value="Herr">Herr</option>
                </SelectField>
            </View>
            <View columnSpan={3}>
                <SelectField
                    name='Titel'
                    label="Titel:"
                    size="small"
                    maxLength={20}
                    placeholder='Titel'
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['TITEL']}
                >
                    <option value="Dr.">Dr.</option>
                    <option value="Dr. med.">Dr. med.</option>
                    <option value="Professor">Professor</option>
                </SelectField>
            </View>

            <View columnSpan={5}>
                <TextField
                    name='Vorname'
                    outerStartComponent={<Button size="small" tabIndex={-1}>Vorname:</Button>}
                    label="Vorname:"
                    size="small"
                    maxLength={30}
                    placeholder='Vorname'
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['VORNAME']}
                />
            </View>

            <View columnSpan={5}>
                <TextField
                    name='NAME'
                    outerStartComponent={<Button size="small" tabIndex={-1}>Name:</Button>}
                    label="Name:"
                    maxLength={50}
                    size="small"
                    placeholder='Name'
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['NAME']}
                />
            </View>

            <View columnSpan={4}>
                <TextField
                    name='STRASSE'
                    outerStartComponent={<Button size="small" tabIndex={-1}>Straße:</Button>}
                    label="Straße:"
                    maxLength={30}
                    size="small"
                    placeholder='Straße'
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['STRASSE']}
                />
            </View>
            <View columnSpan={1}>
                <TextField
                    name='HAUSNUMMER'
                    outerStartComponent={<Button size="small" tabIndex={-1}>Hausnummer:</Button>}
                    label="Hausnummer:"
                    size="small"
                    placeholder='Hausnummer'
                    maxLength={10}
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['HAUSNUMMER']}
                />
            </View>

            <View columnSpan={2}>
                <TextField
                    name='PLZ'
                    outerStartComponent={<Button size="small" tabIndex={-1}>PLZ:</Button>}
                    label="PLZ:"
                    size="small"
                    placeholder='PLZ'
                    maxLength={10}
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['PLZ']}
                />
            </View>
            <View columnSpan={3}>
                <TextField
                    name='ORT'
                    outerStartComponent={<Button size="small" tabIndex={-1}>Ort:</Button>}
                    label="Ort:"
                    size="small"
                    placeholder='Ort'
                    maxLength={30}
                    width="100%"
                    labelHidden={true}
                    onChange={handleChange}
                    value={data['ORT']}
                />
            </View>
            {props.TELEFON_YN === 1 &&
                <>
                    <View></View>
                    <View columnSpan={5}>
                        <TextField
                            name='TELEFON'
                            outerStartComponent={<Button size="small" tabIndex={-1}>Telefon:</Button>}
                            label="Telefon:"
                            maxLength={30}
                            size="small"
                            placeholder='Telefonnummer'
                            width="100%"
                            labelHidden={true}
                            onChange={handleChange}
                            value={data['TELEFON']}
                        />
                    </View>
                </>
            }
        </Grid>
    )
}

const EinverstaendnisItem = (props) => {
    // props.einverstaendnis could be [] OR
    // ID     | MASSNID | CHANGED_AT               | STAMM_ID | TYP  |
    // 4100   | 4102019 | 12.09.2023, 11:49:00.000 |     1    |   0  |  <- Einverständnis OR None
    // 4100   | 4102019 | 15.09.2023, 23:55:00.000 |     1    |   1  |  <- Widerruf       OR None
    // props.einverstaendnisStamm must be
    // ID     | TAG | EINVERSTANDEN | WIDERRUF | DELETED |
    // 1      |  1  | Text          | Text     |    0    |
    // ID === STAMM_ID; TAG === SORTIndex; TYP === 0 => EINVERSTANDEN; TYP === 1 => WIDERRUF; DELETED must be 0 or will not be here
    const initialState = (typ) => {
        if (props.einverstaendnis.length === 0) return { value: false };
        const stateOfTyp = props.einverstaendnis.filter(item => item['TYP'] === typ);
        if (stateOfTyp.length === 0) return { value: false };
        if (stateOfTyp[0]["CHANGED_AT"] > "") return { ...stateOfTyp[0], value: true };
        return { value: false };
    }

    const initialAdresse = (typ) => {
        if (props.einverstaendnis.length === 0) return {};
        const stateOfTyp = props.einverstaendnis.filter(item => item['TYP'] === typ);
        // console.log(stateOfTyp)
        if (stateOfTyp.length === 0) return {};
        if (stateOfTyp[0].hasOwnProperty('ADRESSE')) return stateOfTyp[0]['ADRESSE'];
        return {};
    }
    const [einverstanden, setEinverstanden] = useState(initialState(0)); //
    const [widerrufen, setWiderrufen] = useState(initialState(1));
    const [adresse, setAdresse] = useState(initialAdresse(0));

    // console.log('Einverstanden:', einverstanden);
    // console.log('Wiederrufen:', widerrufen);

    const handleChange = (change) => {
        const now = new Date(Date.now());
        const newEinverstaendnis = { 'CHANGED_AT': getDateTime(now), 'STAMM_ID': props.einverstaendnisStamm["ID"], 'TYP': 0, 'value': true, 'ADRESSE': change }
        //console.log(newEinverstaendnis);
        setEinverstanden({ ...newEinverstaendnis, value: true })
        setWiderrufen({ ...widerrufen, value: false });
        setAdresse(change);
        props.handleChange(newEinverstaendnis);

    }

    const handleClick = (e) => {
        // console.log(e.target);
        const now = new Date(Date.now());
        if (e.target.name === "EINVERST_YN") {
            if (einverstanden.value === false) {
                const newEinverstaendnis = adresse > '' ?
                    { 'CHANGED_AT': getDateTime(now), 'STAMM_ID': props.einverstaendnisStamm["ID"], 'TYP': 0, value: true, 'ADRESSE': adresse } :
                    { 'CHANGED_AT': getDateTime(now), 'STAMM_ID': props.einverstaendnisStamm["ID"], 'TYP': 0, value: true };
                // console.log(newEinverstaendnis);
                // console.log('neu Adresse:', adresse)
                setEinverstanden({ ...newEinverstaendnis });
                setWiderrufen({ ...widerrufen, value: false });
                props.handleChange(newEinverstaendnis);
            }
        }
        if (e.target.name === "WIDERRUF_YN") {
            if (widerrufen.value === false) {
                const newWiderruf = { 'CHANGED_AT': getDateTime(now), 'STAMM_ID': props.einverstaendnisStamm["ID"], 'TYP': 1, value: true }
                //console.log(newWiderruf);
                setWiderrufen({ ...newWiderruf });
                setEinverstanden({ ...einverstanden, value: false });
                props.handleChange(newWiderruf);
            }
        }
    }

    useEffect(() => {
        if (einverstanden.value === true && widerrufen.value === true) {
            setEinverstanden({ ...einverstanden, value: false })
        }

    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // console.log('ein Einverständnis:', props.einverstaendnis)
    return (
        <>
            {props.einverstaendnisStamm.hasOwnProperty('HEADER') && props.einverstaendnisStamm['HEADER'] > '' &&
                <View columnSpan={5}>
                    <Heading level={5}>{props.einverstaendnisStamm['HEADER']}</Heading>
                </View>
            }
            <View columnSpan={5}>
                {props.einverstaendnisStamm.hasOwnProperty('COMMENT') && props.einverstaendnisStamm['COMMENT'] > '' &&
                    ((props.einverstaendnisStamm['COMMENT']).split('<br>')).map((item, i) => {
                        return (
                            <View key={i} columnSpan={5} gap={'0.6rem'}>
                                <Text key={i} style={{ lineHeight: '1em' }}>{item}</Text>
                            </View>
                        )
                    })
                }</View>
            <View columnSpan={5}><Text>{props.einverstaendnisStamm["EINVERSTANDEN"]}</Text></View>
            <View columnSpan={5}>
                {props.einverstaendnisStamm.hasOwnProperty('ADRESSE_YN') && props.einverstaendnisStamm['ADRESSE_YN'] === 1 &&
                    <AdressEingabe
                        handleChange={handleChange}
                        adresse={adresse}
                        PRAXIS_YN={props.einverstaendnisStamm.hasOwnProperty('PRAXIS_YN') ? props.einverstaendnisStamm['PRAXIS_YN'] : 1}
                        TELEFON_YN={props.einverstaendnisStamm.hasOwnProperty('TELEFON_YN') ? props.einverstaendnisStamm['TELEFON_YN'] : 0}
                    />
                }
            </View >
            {
                einverstanden.hasOwnProperty('CHANGED_AT') && einverstanden.value === true && widerrufen.value === false ?
                    <View>
                        <Text fontWeight={650}>{einverstanden['CHANGED_AT'].substring(0, 17)}</Text>
                    </View>
                    :
                    <View>
                        <Button

                            name={"EINVERST_YN"}
                            onClick={handleClick}
                            size="large"
                            variation="primary"
                        >Einverstanden</Button>
                    </View>
            }
            < View columnSpan={4} >

            </View >

            {(einverstanden.value === true || widerrufen.value === true) &&
                widerrufen.hasOwnProperty('CHANGED_AT') && widerrufen.value === true ?
                <View>
                    <Text fontWeight={650}>{widerrufen['CHANGED_AT'].substring(0, 17)}</Text>
                </View>
                : einverstanden.value === true &&
                <View >
                    <Button

                        name={"WIDERRUF_YN"}
                        onClick={handleClick}
                        size="large"
                        variation="primary"
                    >&nbsp;&nbsp;Widerrufen&nbsp;&nbsp;</Button>
                </View>

            }
            {
                (einverstanden.value === true || widerrufen.value === true) &&
                <View columnSpan={4}>
                    <Text>{props.einverstaendnisStamm["WIDERRUF"]}</Text>
                </View>
            }
            <View columnSpan={5}>
                <Divider orientation="horizontal" />
            </View>
        </>
    );
}

const EinverstaendnisListe = (props) => {
    // console.log(props.einverstaendnisStamm);
    return (
        <Grid
            columnGap='0.5rem'
            rowGap='0.5rem'
            templateColumns={{ base: "1fr", medium: "1fr 1fr 1fr 1fr 8fr" }}
        >
            {props.einverstaendnisStamm.map((item, i) =>
                <EinverstaendnisItem
                    einverstaendnisStamm={item}
                    key={"EV_" + i}
                    handleChange={props.handleChange}
                    einverstaendnis={props.einverstaendnis ? props.einverstaendnis.filter(v => v.STAMM_ID === item.ID) : []}
                />
            )}
        </Grid>
    );
}

const Einverstaendnis = () => {
    const { user } = useAuthenticator((context) => [context.user]);
    const [einverstaendnis, setEinverstaendnis] = useState();
    const [einverstaendnisStamm, setEinverstaendnisStamm] = useState();
    const [sticky, setSticky] = useState(undefined);
    const [show, setShow] = useState(false);
    const [origin, setOrigin] = useState([]);
    const [saved, setSaved] = useState(null);
    const filename = "Einverstaendnis.json";
    const filenameOfStamm = "EinverstaendnisStamm.json";


    // console.log('Einverstaendnis')

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const showFooter = false;


    //    useBlocker("Are you sure you want to leave?", sticky);   // wait for version 6 is completed and useBlocker back

    useEffect(() => {
        window.onbeforeunload = function () {
            if (sticky) {
                return "Sie haben nicht gespeicherte Änderungen?";
            }
        };
    }, [sticky]);

    function handleChange(value) {
        const einv = einverstaendnis.filter(elem => elem['STAMM_ID'] !== value['STAMM_ID'])
        delete value.value
        // console.log(einverstaendnis);
        // console.log(value);
        setEinverstaendnis([...einv, value]);
        setSticky(true);
    }

    const storeEinverstaendnisstamm = (data) => {
        // console.log('storeEinverstaendnisstamm:', data.hasOwnProperty("EINVERSTAENDNISSTAMM") ? data["EINVERSTAENDNISSTAMM"] : [])
        setEinverstaendnisStamm(data.hasOwnProperty("EINVERSTAENDNISSTAMM") ? data["EINVERSTAENDNISSTAMM"] : []);
    }

    const storeEinverstaendnis = (data) => {
        if (data.hasOwnProperty('EINVERSTAENDNIS')) {
            const myData = data['EINVERSTAENDNIS'];
            // console.log(myData)
            setEinverstaendnis(myData);
            setOrigin([...myData]);
        }
        else {
            // console.log('file not found')
            setEinverstaendnis([]);
            setOrigin([]);
        }
        setSticky(false);
    }

    const handleS3Einverstaendnis = (result) => {
        const keys = Object.keys(result);
        if (keys.includes(filename)) {
            // console.log('keys', keys)
            s3ReadFile(filename, 'private', storeEinverstaendnis)
        } else {
            storeEinverstaendnis([])
        }
    }

    const handleSaveButton = (e) => {
        e.preventDefault();
        // console.log('Origin: ', origin);
        // console.log('einverstaendnis:', einverstaendnis);
        const toBeSaved = [];
        einverstaendnisStamm.forEach(stamm => {
            const originTyp = origin.filter(item => item['STAMM_ID'] === stamm['ID']);
            const einvTyp = einverstaendnis.filter(item => item['STAMM_ID'] === stamm['ID']);
            // console.log('originTyp:', originTyp);
            // console.log('einvTyp:', einvTyp)
            if (originTyp.length === 0 && einvTyp.length === 0) return; // nix da, nix machen
            if (originTyp.length === 0 && einvTyp.length === 1 && einvTyp[0]['TYP'] === 0) toBeSaved.push(einvTyp[0]); // nur neues Einverständnis sichern
            if (originTyp.length > 0 && einvTyp.length === 0) {
                toBeSaved.push(originTyp[0]); // nur alte Daten sichern;
                if (originTyp.length === 2) toBeSaved.push(originTyp[1]); // nur alte Daten sichern;
                // console.log('Error einvTyp ist leer:', originTyp);
            }
            // wenn vorher kein Widerspruch da war, aber vorher ein Einverstanden, dann Original Einverstanden und neuen Widerspruch sichern
            // wenn vorher ein Widerspruch da war, dann nur neuen Einverstanden sichern

            if (originTyp.length > 0 && einvTyp.length > 0) {
                const orgWider = originTyp.filter(item => item['TYP'] === 1);
                const orgEinv = originTyp.filter(item => item['TYP'] === 0);
                const einvWider = einvTyp.filter(item => item['TYP'] === 1);
                const einvEinv = einvTyp.filter(item => item['TYP'] === 0);
                //console.log('Original:', orgEinv, orgWider);
                //console.log('Einverständnis:', einvEinv, einvWider)
                if (orgWider.length === 0 && einvWider.length === 1) {
                    // wenn vorher kein Widerspruch da war, aber vorher ein Einverstanden, dann Original Einverstanden und neuen Widerspruch sichern
                    if (orgEinv.length === 1) {
                        toBeSaved.push(orgEinv[0]);
                        toBeSaved.push(einvWider[0]);
                    }
                } else {
                    if (einvTyp.length === 1) {
                        // wenn vorher ein Widerspruch da war, dann nur neuen Einverstanden sichern
                        toBeSaved.push(einvEinv[0]);
                    }
                    if (einvTyp.length === 2) {
                        // wenn dafür nichts geändert worden ist, dann beide eintragen
                        toBeSaved.push(einvEinv[0]);
                        toBeSaved.push(einvWider[0]);
                    }
                }
            }

        });
        // console.log('Ergebnis:', toBeSaved);
        setEinverstaendnis(toBeSaved);
        setOrigin(toBeSaved);
        // console.log(user)
        s3WriteFile(filename, { 'EINVERSTAENDNIS': toBeSaved, User: user.username, MASSNID: user.attributes['custom:kvsID'] }, "private", "text/plain");
        setSticky(false);
        setSaved(setTimeout(() => {
            setSaved(null);
        }, 1000))
    }

    useEffect(() => {

        if (!einverstaendnisStamm || einverstaendnisStamm.length < 1) {
            s3ReadFile(filenameOfStamm, 'public', storeEinverstaendnisstamm);
        }

        if (!einverstaendnis || einverstaendnis.length < 1) {
            // console.log('useEffect no daten')
            s3ListObjects('', 'private', handleS3Einverstaendnis);
        }
        return () => {
            setEinverstaendnisStamm([])
            setEinverstaendnis([])
            if (saved != null) {
                clearTimeout(saved);
                setSaved(null);
            }
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // console.log('--> Daten... isLoaded=%s, values', isLoaded, daten)
    // console.log('Start-Date is:', values[0]['DATUM_VON'])

    // style={{ position: "sticky", top: 100, display: "flex", justifyContent: "flex-end" }}

    if (!user) {
        return (<Navigate to='/profile' replace={true} />)
    }

    /*
        if (!daten || daten.length  === undefined || daten.length === 0) {
            return null;
        }
    */
    // console.log('neu befüllte MenueWahlListe:', daten)
    // style={{
    //    backgroundImage: `url(${background})`,
    // }}
    return (
        <Container fluid >
            {!einverstaendnisStamm && <Loading loadingtext="Einverständnis Stammdaten" />}
            {!einverstaendnis && <Loading loadingtext="Einverständniserklärungen" />}
            {einverstaendnisStamm && einverstaendnis &&
                <>
                    <form onSubmit={handleSaveButton}>
                        <div
                            className="floating-div"
                            style={{
                                position: "fixed",
                                right: "10px",
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "0.5rem",
                                padding: "1rem",
                                zIndex: "50"
                            }}>
                            <Button style={{ backgroundColor: 'white'}} variant="light" onClick={handleShow}>Hilfe</Button>
                            {sticky &&
                                <Button
                                    size='large'
                                    gap="1rem"
                                    type="submit"
                                    variation="primary"
                                > <MdSave />&nbsp;Speichern</Button>
                            }
                            {saved && <Button
                                size='large'
                                gap="1rem"
                                variation="primary"
                            > <MdDoneOutline />&nbsp;gespeichert</Button>}
                        </div>
                        <Offcanvas show={show} onHide={handleClose}>
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>Erläuterungen</Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <p>Wir benötigen Ihre Einwilligung um Ihre persönlichen Daten verarbeiten zu dürfen...</p>
                                <p>Laut DSGVO (Artikel 7 Erwägungsgrund 32) besteht kein Formerfordernis für die Einwilligung. Sie kann daher auch in elektronischer Form erfolgen.</p>
                                <p>Wir speichern diese Einwilligung für die einzeln aufgeführten Punkte in unserer Datenbank.</p>
                                <p>Sie können Ihre Einwilligung jederzeit widerrufen.</p>
                                <p>Auch das speichern wir mit dem Zeitpunkt in unserer Datenbank.</p>
                                <p>Damit ist eine Nachvollziehbarkeit gewährleistet.</p>
                                <p></p>
                                <p>Bei einem Widerruf bemühen wir uns selbstverständlich, auch nachgeordnete Systeme und Beteiligte darüber zu informieren.</p>
                                <p>Falls dabei keine Automatismen eingesetzt werden, kann dies jedoch einige Zeit der Bearbeitung erfordern. Dafür bitten wir um Verständnis.</p>
                                <p>-----</p>
                                <p>Nach einer Änderung erscheint das Feld "Speichern"; vergessen Sie bitte nicht Ihre Auswahl durch anklicken zu speichern.</p>
                                <p></p>
                                <p>Die gespeicherten Änderungen werden ein mal täglich übernommen, weshalb sie auch erst am nächsten Tag wirken.</p>
                            </Offcanvas.Body>
                        </Offcanvas>
                        <Heading level={2}>Einverständniserklärungen:</Heading>
                        <Text>
                            Der Schutz personenbezogener Daten ist uns sehr wichtig. Wir möchten, dass Sie wissen, dass wir über den gesamten Aufenthalt in unserer Klinik sehr sorgsam mit Ihren persönlichen Daten umgehen und diese niemandem ungerechtfertigt bzw. ohne Ihr Einverständnis zur Verfügung stellen.
                        </Text>
                        <Text>
                            Die Verarbeitung Ihrer Daten erfolgt nach Art. 6 Abs.1 lit. f DSGVO, dem Bundesdatenschutzgesetz (§284 u. §301 SGB V bzw. § 184 SGB VI) und den Vorschriften über die ärztliche Schweigepflicht.
                        </Text>
                        <Text>
                            Weitergegeben werden Ihre Daten nur im gesetzlich vorgeschriebenen Umfang bzw. wenn es für die Therapie/Diagnostik während des Aufenthaltes notwendig ist. Eine Weitergabe erfolgt z.B. an folgende Stellen:
                        </Text>
                        <ul>
                            <li>Medizinischer Dienst der Kostenträger</li>
                            <li>öffentl. Stellen (z.B. Sozialgerichte oder Landratsämter bei Antrag nach Schwerbehindertenrecht), sofern die Herausgabe rechtlich zulässig ist oder Ihre Einverständniserklärung vorliegt</li>
                            <li>Kurverwaltung Bad Mergentheim für die Erhebung der Kurtaxe (§11 (1) der Kurtaxesatzung der Stadt Bad Mergentheim)</li>
                            <li>Externe Ärzte oder Labore, die in unserem Auftrag notwendige Untersuchungen durchführen</li>
                            <li>Vorbehandelnde Ärzte oder Kliniken</li>
                            <li>Externer Dienstleister im Zusammenhang mit digitaler Therapie</li>
                        </ul>
                        <Text><b>ACHTUNG:</b> Die DSGVO schreibt vor, dass Sie die Erklärungen tatsächlich einzeln mit Druck auf den jeweiligen Button <Button variation="primary" size="small">Einverstanden</Button> bestätigen müssen, erst dann sehen Sie das Datum und die Uhrzeit Ihrer Bestätigung.</Text>
                        <Text>Vergessen Sie bitte nicht, nach der Bearbeitung aller Erklärungen diese zu speichern.</Text>
                        <Divider orientation="horizontal" />
                        <EinverstaendnisListe
                            handleChange={handleChange}
                            einverstaendnisStamm={einverstaendnisStamm}
                            einverstaendnis={einverstaendnis}
                            key='dummy'
                        />

                        {sticky && showFooter &&
                            <Footer>
                                <Button
                                    size='large'
                                    gap="1rem"
                                    type="submit"
                                ><MdSave />Speichern</Button>
                            </Footer>
                        }
                    </form>
                </>
            }
        </Container>
    )
}

export default Einverstaendnis;